module.exports = __webpack_public_path__ + "img/placeholder.3552ff7c.jpg";